export const DATASWITCHTYPEMENUCOMPOSER = 'DATA_SWITCH_TYPE_MENU_COMPOSER';

export interface DataSwitchTypeMenuComposer {
  type: typeof DATASWITCHTYPEMENUCOMPOSER;
  data: any;
}